export const SET_HC_ID = 'SET_HC_ID';